/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowTechTalkTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowTechTalk,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Talk Tech!",
    "Tech Talk Awaits!",
    "Dive into Technology!",
  ],
  title: "Tech Talk",
  description: "Organize an engaging tech talk.",
  longDescription:
    "Gather your friends for a tech talk! Choose a date, decide on topics to cover, and plan activities for the session!",
  emoji: "💻",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Tech Talk",
          emoji: "💻",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the tech talk?",
          emoji: "📅",
          completeAction: {
            question: "Decide on topics to cover?",
            description:
              "What topics do we want to explore during the tech talk?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What topics should we consider?",
                emoji: "🔧",
                completeAction: {
                  question: "Decide on tools needed?",
                  description: "What tools should we gather for the talk?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "🛠",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Talk Tech!",
    outroDescription: "Your tech talk plans are set! Enjoy the discussion!",
  },
};
